module.exports = __webpack_public_path__ + "media/images/social/fb-71a20646b9fa26a6b5311f584e21cd84.svg";